// Konfiguration der Portionsrechner-Landingpages. Geteilt von React-Pages und
// scripts/prerender.js (vm-Shim, daher reines `export const`).
export const PORTION_SEITEN = [
  {
    slug: "reis-pro-person",
    food: "reis",
    title: "Wie viel Reis pro Person? Menge für X Personen berechnen",
    description: "Reismenge pro Person und für mehrere Personen berechnen. Als Beilage oder Hauptgericht, roh in Gramm.",
    h1: "Wie viel Reis pro Person?",
    intro: "Als Beilage rechnet man etwa 60 bis 70 g rohen Reis pro Person, als Hauptgericht rund 100 bis 120 g. Gib die Personenzahl ein, der Rechner zeigt die Gesamtmenge, zum Beispiel für 10 Personen.",
    faq: [
      { q: "Wie viel Reis pro Person als Beilage?", a: "Etwa 60 bis 70 g roher Reis pro Person. Gekocht nimmt Reis rund das 2,5- bis 3-fache an Gewicht zu." },
      { q: "Wie viel Reis für 10 Personen?", a: "Als Hauptgericht etwa 1,1 kg roher Reis (110 g pro Person), als Beilage rund 650 g." },
    ],
  },
  {
    slug: "nudeln-pro-person",
    food: "nudeln",
    title: "Wie viel Nudeln pro Person? Menge für X Personen berechnen",
    description: "Nudelmenge pro Person und für mehrere Personen berechnen. Als Beilage oder Hauptgericht, roh in Gramm.",
    h1: "Wie viel Nudeln pro Person?",
    intro: "Als Hauptgericht rechnet man etwa 100 bis 125 g rohe Nudeln pro Person, als Beilage rund 60 bis 80 g. Gib die Personenzahl ein und sieh die Gesamtmenge.",
    faq: [
      { q: "Wie viel Nudeln pro Person als Hauptgericht?", a: "Etwa 100 bis 125 g rohe Nudeln pro Person. Bei großem Hunger oder ohne Beilage eher mehr." },
    ],
  },
  {
    slug: "spaghetti-pro-person",
    food: "spaghetti",
    title: "Wie viel Spaghetti pro Person? Menge berechnen",
    description: "Spaghetti-Menge pro Person und für mehrere Personen berechnen, als Beilage oder Hauptgericht.",
    h1: "Wie viel Spaghetti pro Person?",
    intro: "Für Spaghetti als Hauptgericht rechnet man etwa 100 bis 125 g pro Person, als Beilage rund 70 g. Gib die Personenzahl ein, der Rechner zeigt die Gesamtmenge.",
    faq: [
      { q: "Wie viel Spaghetti für 4 Personen?", a: "Als Hauptgericht rund 460 g (115 g pro Person)." },
    ],
  },
  {
    slug: "kartoffeln-pro-person",
    food: "kartoffeln",
    title: "Wie viel Kartoffeln pro Person? Menge für X Personen",
    description: "Kartoffelmenge pro Person und für mehrere Personen berechnen, als Beilage oder Hauptgericht.",
    h1: "Wie viel Kartoffeln pro Person?",
    intro: "Als Beilage rechnet man etwa 200 bis 250 g Kartoffeln pro Person, als Hauptgericht rund 300 g. Praktisch zum Beispiel für Raclette oder ein größeres Essen.",
    faq: [
      { q: "Wie viel Kartoffeln für 20 Personen?", a: "Als Beilage rund 4 kg (200 g pro Person), als Hauptgericht etwa 6 kg." },
    ],
  },
];

export const PORTION_HUB = {
  slug: "portionsrechner",
  title: "Portionsrechner: Mengen pro Person für Reis, Nudeln, Kartoffeln",
  description: "Kostenloser Portionsrechner: wie viel Reis, Nudeln, Spaghetti oder Kartoffeln pro Person und für X Personen. Beilage oder Hauptgericht.",
  h1: "Portionsrechner: Mengen pro Person",
  faq: [
    { q: "Wie viel Beilage pro Person?", a: "Als Faustregel: Reis und Nudeln 60 bis 80 g (Beilage) bzw. 100 bis 125 g (Hauptgericht) roh, Kartoffeln 200 bis 250 g. Der Rechner rechnet das auf deine Personenzahl hoch." },
    { q: "Sind die Mengen roh oder gekocht?", a: "Roh. Reis und Nudeln nehmen beim Kochen etwa das 2,5- bis 3-fache an Gewicht zu." },
  ],
};
